@for (badge of badges; track badge) {<span
  class="badge {{ badge.class }}"
  >{{ badge.value }}</span
>}
